import { jsx as s } from "react/jsx-runtime";
import { createContext as h, useMemo as v, useState as w, useEffect as d, useContext as g } from "react";
import { useGrowthBook as P, GrowthBook as F, GrowthBookProvider as E, useFeatureValue as C } from "@growthbook/growthbook-react";
import { uiEventEmitter as m } from "@made-people/grease-ui-events";
import { ManagedPropsProvider as x } from "@made-people/managed-props";
import { flattener as p } from "@made-people/flatten-object";
import { createEventEmitter as N } from "@made-people/grease-event-emitter";
function f(e) {
  const t = e.getFeatures();
  return Object.keys(t).sort().map((n) => {
    var o;
    return {
      featureId: n,
      value: e.getFeatureValue(
        n,
        (o = t[n]) == null ? void 0 : o.defaultValue
      )
    };
  });
}
const k = h(void 0), D = (e) => {
  const t = P(), n = v(
    () => e.activeFeatures ?? f(t),
    [t]
  ), [o, a] = w(n);
  return d(() => {
    const r = t.subscribe(() => {
      a((i) => {
        const u = f(t);
        return I(i, u) ? i : u;
      });
    });
    return () => r == null ? void 0 : r();
  }, [t]), /* @__PURE__ */ s(k.Provider, { value: o, children: e.children });
}, y = () => g(k);
function I(e, t) {
  var n, o, a, r;
  if (e === t)
    return !0;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (let i = 0; i < e.length; i++)
    if (((n = e[i]) == null ? void 0 : n.featureId) !== ((o = t[i]) == null ? void 0 : o.featureId) || !Object.is((a = e[i]) == null ? void 0 : a.value, (r = t[i]) == null ? void 0 : r.value))
      return !1;
  return !0;
}
const G = h(void 0), V = (e) => /* @__PURE__ */ s(
  G.Provider,
  {
    value: e.viewedExperiments,
    children: e.children
  }
);
function O() {
  return g(G);
}
const A = (e) => {
  const t = v(() => {
    if (e.client)
      return e.client;
    if (!e.payload)
      throw new Error(
        "GreaseGrowthbookClientProvider: You must provide either a client or payload"
      );
    const n = [], o = e.attributes ?? {};
    if (typeof document < "u") {
      const a = e.cookieName ?? "gbuuid", r = document.cookie.split("; ").find((u) => u.startsWith(a + "=")), i = r ? (
        // @ts-expect-error - TS doesn't know that match is not undefined
        decodeURIComponent(r.split("=")[1])
      ) : null;
      o.id = i;
    }
    return new F({
      ...e.clientOptions,
      attributes: o,
      plugins: n
    }).initSync({
      payload: e.payload
    });
  }, [
    e.client,
    e.clientOptions,
    e.attributes,
    e.payload,
    e.cookieName
  ]);
  return d(() => {
    if (!t)
      return;
    const n = (o) => {
      const a = new URL(window.location.origin + o.to);
      t.setURL(a.toString()), t.setAttributes({
        ...t.getAttributes(),
        url: a.toString(),
        urlPathname: a.pathname
      });
    };
    return m.on("routeChanged", (o) => n(o)), () => {
      m.off("routeChanged", (o) => n(o));
    };
  }, [t]), /* @__PURE__ */ s(E, { growthbook: t, children: /* @__PURE__ */ s(
    V,
    {
      viewedExperiments: e.viewedExperiments,
      children: e.children
    }
  ) });
};
function Y() {
  try {
    return P();
  } catch {
    return;
  }
}
function _(e, t) {
  try {
    return C(e, t);
  } catch {
    return;
  }
}
const z = (e) => {
  const t = O();
  return e.forceDisplay === !0 || t && t[e.experimentId] === e.variationId ? e.children : null;
};
function M(e, t) {
  const n = p(t.propDelimiter), a = e.filter(
    (r) => r.featureId.includes(t.componentNameDelimiter)
  ).reduce(
    (r, i) => {
      const [u, c] = i.featureId.split(
        t.componentNameDelimiter
      );
      return u && c && (r[u] || (r[u] = {}), r[u][c] = i.value), r;
    },
    {}
  );
  return Object.fromEntries(
    Object.entries(a).map(([r, i]) => {
      const u = n.unflatten(i);
      return [r, u];
    })
  );
}
const j = (e) => {
  var u, c;
  const t = y(), [n, o] = w(
    (e.deferredComponentNames ?? []).reduce((l, b) => (l[b] = null, l), {})
  ), a = e.componentNameDelimiter ?? "::", r = e.propDelimiter ?? "_";
  d(() => {
    if (t != null && t.length) {
      const l = M(t, {
        componentNameDelimiter: a,
        propDelimiter: r
      });
      o(l);
    }
  }, [t]);
  const i = {
    fallbackProps: (u = e.managedProps) == null ? void 0 : u.fallbackProps,
    overrideProps: (c = e.managedProps) == null ? void 0 : c.overrideProps,
    deferredOverrideProps: n
  };
  return /* @__PURE__ */ s(x, { value: i, children: e.children });
}, H = (e) => /* @__PURE__ */ s(A, { ...e.clientProviderProps, children: /* @__PURE__ */ s(
  D,
  {
    ...e.activeFeaturesProviderProps,
    children: /* @__PURE__ */ s(
      j,
      {
        deferredComponentNames: e.deferredComponentNames,
        managedProps: e.managedProps,
        children: e.children
      }
    )
  }
) }), J = N();
export {
  D as GreaseGrowthbookActiveFeaturesProvider,
  A as GreaseGrowthbookClientProvider,
  z as GreaseGrowthbookExperimentContainer,
  j as GreaseGrowthbookManagedPropsProvider,
  H as GreaseGrowthbookProvider,
  V as GreaseGrowthbookViewedExperimentsProvider,
  f as getGrowthbookFeaturesFromClient,
  J as greaseGrowthbookEventEmitter,
  k as growthbookActiveFeaturesContext,
  M as resolveGrowthbookManagedProps,
  Y as useGreaseGrowthbook,
  y as useGreaseGrowthbookActiveFeatures,
  _ as useGreaseGrowthbookFeatureValue,
  O as useGreaseGrowthbookViewedExperiments
};
//# sourceMappingURL=lib.es.js.map
